import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "list-group list-group-flush list-group-form-fieldset-nav sticky-below-page-nav",
  id: "list-group-form-fieldset-nav"
}
const _hoisted_2 = {
  href: "#accordion-header-action-description",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center active",
  "aria-current": "true"
}
const _hoisted_3 = {
  href: "#accordion-header-files",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
}
const _hoisted_4 = {
  href: "#accordion-header-links",
  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "table table-hover border-top border-black-10" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "btn btn-secondary",
  type: "submit"
}
const _hoisted_13 = {
  class: "accordion accordion-flush",
  id: "accordion-actions",
  "data-bs-spy": "scroll",
  "data-bs-target": "#list-group-form-fieldset-nav",
  "data-bs-offset": "0"
}
const _hoisted_14 = { class: "accordion-item" }
const _hoisted_15 = {
  class: "accordion-header",
  id: "accordion-header-action-description"
}
const _hoisted_16 = {
  class: "accordion-button",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapse-action-description",
  "aria-expanded": "true",
  "aria-controls": "collapse-action-description"
}
const _hoisted_17 = {
  class: "accordion-collapse collapse show",
  id: "collapse-action-description",
  "aria-labelledby": "accordion-header-action-description"
}
const _hoisted_18 = { class: "h4 mb-3" }
const _hoisted_19 = { class: "form-check form-check-inline" }
const _hoisted_20 = {
  class: "form-check-label",
  for: "legal_requirement_yes"
}
const _hoisted_21 = { class: "form-check form-check-inline" }
const _hoisted_22 = {
  class: "form-check-label",
  for: "legal_requirement_no"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "accordion-item" }
const _hoisted_25 = {
  class: "accordion-header",
  id: "accordion-header-files"
}
const _hoisted_26 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapse-files",
  "aria-expanded": "false",
  "aria-controls": "collapse-files"
}
const _hoisted_27 = {
  class: "accordion-collapse collapse",
  id: "collapse-files",
  "aria-labelledby": "accordion-header-files"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "table table-hover border-top border-black-10" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 4,
  class: "btn btn-primary",
  disabled: ""
}
const _hoisted_37 = { class: "accordion-item" }
const _hoisted_38 = {
  class: "accordion-header",
  id: "accordion-header-links"
}
const _hoisted_39 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapse-links",
  "aria-expanded": "false",
  "aria-controls": "collapse-links"
}
const _hoisted_40 = {
  class: "accordion-collapse collapse",
  id: "collapse-links",
  "aria-labelledby": "accordion-header-links"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_SubHeader = _resolveComponent("SubHeader")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_ReadOnlyAction = _resolveComponent("ReadOnlyAction")!
  const _component_MainFormBottomBar = _resolveComponent("MainFormBottomBar")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_FormTextarea = _resolveComponent("FormTextarea")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ActionFileUpload = _resolveComponent("ActionFileUpload")!
  const _component_MainFormContainer = _resolveComponent("MainFormContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, { position: "" }),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_SubHeader, {
          key: 0,
          "link-to-overview": `/application_actions_overview/${_ctx.application.id}`,
          "link-to-overview-title": _ctx.$t('text.back_to_actions')
        }, null, 8, ["link-to-overview", "link-to-overview-title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MainFormContainer, {
      title: _ctx.$t('actions.action_details')
    }, {
      "form-fieldsets-nav": _withCtx(() => [
        (_ctx.isLoaded && !_ctx.applicationInReadonlyMode(_ctx.application, _ctx.currentApplicationPeriod))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$t('actions.description_of_action')), 1),
              _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('actions.action_appendix')), 1),
              _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('actions.link_to_field_of_action')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      form: _withCtx(() => [
        _createVNode(_component_Alerts, { sticky: "sticky-below-page-nav" }),
        (_ctx.isLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.applicationInReadonlyMode(_ctx.application, _ctx.currentApplicationPeriod))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_ReadOnlyAction, {
                      "application-action": _ctx.instance,
                      "fields-of-action": _ctx.fieldsOfAction
                    }, null, 8, ["application-action", "fields-of-action"]),
                    (_ctx.actionFiles.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('actions.action_appendix')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('actions.action_files_subtitle')), 1),
                          _createElementVNode("table", _hoisted_8, [
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionFiles, (file) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: file.id
                                }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      href: file.uploaded_file,
                                      target: "_blank"
                                    }, _toDisplayString(file.name), 9, _hoisted_9)
                                  ]),
                                  _hoisted_10
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_Form, {
                      onSubmit: _ctx.storeApplicationAction,
                      label: _ctx.$t('actions.form_title'),
                      "initial-values": _ctx.instance,
                      "validation-schema": _ctx.schema,
                      id: "action-form"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MainFormBottomBar, null, {
                          default: _withCtx(() => [
                            _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.$t('text.save')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("button", _hoisted_16, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('actions.description_of_action')), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_FormInput, {
                                type: "text",
                                label: _ctx.$t('text.title'),
                                name: "title",
                                required: ""
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.short_description'),
                                name: "short_description"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.goals_and_milestones'),
                                name: "goals_and_milestones"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.anchor_points_and_responsible_persons'),
                                name: "anchor_points_and_responsible_persons"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.involved_persons'),
                                name: "involved_persons"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.timings_and_procedure'),
                                name: "timings_and_procedure"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.costs_and_financing'),
                                name: "costs_and_financing"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormTextarea, {
                                type: "text",
                                label: _ctx.$t('actions.evaluation_and_monitoring'),
                                name: "evaluation_and_monitoring"
                              }, null, 8, ["label"]),
                              _createVNode(_component_FormInput, {
                                type: "url",
                                name: "link_to_describe",
                                label: _ctx.$t('actions.link_to_describe')
                              }, null, 8, ["label"]),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('actions.legal_requirement')), 1),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_Field, {
                                    name: "legal_requirement",
                                    type: "radio",
                                    value: true,
                                    id: "legal_requirement_yes",
                                    class: "form-check-input"
                                  }),
                                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('text.yes')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_Field, {
                                    name: "legal_requirement",
                                    type: "radio",
                                    value: false,
                                    id: "legal_requirement_no",
                                    class: "form-check-input"
                                  }),
                                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('text.no')), 1)
                                ])
                              ]),
                              _hoisted_23
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("button", _hoisted_26, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('actions.action_appendix')), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              (_ctx.actionFiles.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('actions.action_files_subtitle')), 1),
                                    _createElementVNode("table", _hoisted_29, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionFiles, (file) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: file.id
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("a", {
                                                href: file.uploaded_file,
                                                target: "_blank"
                                              }, _toDisplayString(file.name), 9, _hoisted_30)
                                            ]),
                                            _createElementVNode("td", _hoisted_31, [
                                              _createElementVNode("a", {
                                                href: "",
                                                onClick: _withModifiers(($event: any) => (_ctx.deleteActionFile(file.id)), ["prevent"])
                                              }, _toDisplayString(_ctx.$t('text.delete')), 9, _hoisted_32)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : (!_ctx.currentID)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('actions.action_files_empty')) + " ", 1),
                                      _hoisted_34,
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.save_first')), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.$t('actions.action_files_empty')), 1)),
                              (_ctx.currentID)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    class: "btn btn-primary",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showActionFileUploadForm && _ctx.showActionFileUploadForm(...args)), ["prevent"]))
                                  }, _toDisplayString(_ctx.$t('actions.add_file')), 1))
                                : (_openBlock(), _createElementBlock("button", _hoisted_36, _toDisplayString(_ctx.$t('actions.add_file')), 1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", _hoisted_39, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('actions.link_to_field_of_action')), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('actions.fields_of_action_subtitle')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsOfAction, (field, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: field.id
                                }, [
                                  _createVNode(_component_Field, {
                                    name: "field_of_action",
                                    type: "checkbox",
                                    value: field.id
                                  }, null, 8, ["value"]),
                                  _createTextVNode(_toDisplayString(_ctx.$tc('fields_of_action.field_no_with_count', {number: index + 1, count: field.actions.length})) + " ", 1),
                                  _hoisted_41,
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.getFieldTitle(field.field_of_action_type))), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["onSubmit", "label", "initial-values", "validation-schema"])
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('application.loading')), 1)
            ])),
        _createVNode(_component_ActionFileUpload, {
          ref: "actionFileUpload",
          "size-class": "modal-lg",
          "action-id": _ctx.instance.id,
          onFileUploaded: _ctx.reloadFiles
        }, null, 8, ["action-id", "onFileUploaded"])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}